import { supabase } from "../lib/supabaseClient";

const EVENT_ASSETS_BUCKET = "event-assets";
const EVENT_ASSETS_PUBLIC_MARKER = `/storage/v1/object/public/${EVENT_ASSETS_BUCKET}/`;
const EVENT_ASSETS_SIGNED_MARKER = `/storage/v1/object/sign/${EVENT_ASSETS_BUCKET}/`;

const requireClient = () => {
  if (!supabase) {
    throw new Error("Supabase is not configured.");
  }

  return supabase;
};

const getFileExtension = (file) => {
  const fromName = file.name?.split(".").pop();
  if (fromName) return fromName.toLowerCase();

  const fromType = file.type?.split("/").pop();
  return fromType || "png";
};

export const uploadEventImage = async ({ file, userId }) => {
  const client = requireClient();
  const extension = getFileExtension(file);
  const filePath = `${userId}/${crypto.randomUUID()}.${extension}`;

  const { error } = await client.storage
    .from(EVENT_ASSETS_BUCKET)
    .upload(filePath, file, {
      cacheControl: "31536000",
      contentType: file.type,
      upsert: false,
    });

  if (error) throw error;

  const { data } = client.storage.from(EVENT_ASSETS_BUCKET).getPublicUrl(filePath);
  return data.publicUrl;
};

export const parseEventAssetPath = (imageUrl) => {
  if (typeof imageUrl !== "string" || imageUrl.startsWith("data:")) {
    return null;
  }

  try {
    const { pathname } = new URL(imageUrl);
    const marker = [EVENT_ASSETS_PUBLIC_MARKER, EVENT_ASSETS_SIGNED_MARKER]
      .find((candidate) => pathname.includes(candidate));

    if (!marker) {
      return null;
    }

    const path = pathname.slice(pathname.indexOf(marker) + marker.length);
    return path ? decodeURIComponent(path) : null;
  } catch {
    return null;
  }
};

export const deleteEventImage = async ({ filePath, imageUrl }) => {
  const path = filePath || parseEventAssetPath(imageUrl);
  if (!path) {
    return false;
  }

  const client = requireClient();
  const { error } = await client.storage
    .from(EVENT_ASSETS_BUCKET)
    .remove([path]);

  if (error) throw error;
  return true;
};
